module.exports = __webpack_public_path__ + "static/media/BrentNovoselsky.fa1f7c2b.jpg";